import React from "react";
import AssociatedEntity from "../../AssociatedEntity/AssociatedEntity";
import "./CalendarTaskCard.css";
const CalendarTaskCard = ({ event, showLead = true }) => {
  return (
    <div className={`calendar-task-card ${showLead || "small-card-variant"}`}>
      <div
        className="event-name"
        style={{ background: event?.color || "rgb(var(--ng-grey-50))" }}
      ></div>
      <div className="task-name overflow-ellipsis ng_p_2_sb" title={event?.name}>
        {event?.name}
      </div>
      {showLead && <AssociatedEntity event={event} />}
    </div>
  );
};

export default CalendarTaskCard;
